"use client";
import MenuIcon from "@mui/icons-material/Menu";
import { usePathname } from "next/navigation";
import { useState } from "react";
import Link from "~/components/Link";
import LogoLink from "./LogoLink";
import StoreFrontDrawer from "./StoreFrontDrawer";
import StoreFrontRightArea from "./StoreFrontRightArea";
import UnpaidOrdersPopup from "./UnpaidOrdersPopup";
import { storeFrontMenuEntries } from "./storeFrontMenuEntries";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";

export default function StoreFrontNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <AppBar
        position="static"
        enableColorOnDark
        color="default"
        elevation={0}
        sx={{
          bgcolor: "background.default",
          color: "background.contrastText",
          transition: "all 0.3s ease-in-out",
          colorScheme: "light",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              justifyContent: "space-between",
              minHeight: { xs: 48, md: 56 },
            }}
          >
            {/* Mobile: Hamburger on left - hidden on desktop */}
            <Tooltip title="Deschide meniul">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ display: { xs: "inline-flex", md: "none" } }}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>

            {/* Logo - centered on mobile, left on desktop */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                position: { xs: "absolute", md: "static" },
                left: { xs: "50%", md: "auto" },
                transform: { xs: "translateX(-50%)", md: "none" },
                mr: { xs: 0, md: 3 },
              }}
            >
              <LogoLink />
            </Box>

            {/* Desktop Navigation - hidden on mobile */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 0.5 }}>
              {storeFrontMenuEntries.map((item) => (
                <Link
                  button
                  href={item.href}
                  key={item.label}
                  color="inherit"
                  sx={{
                    fontWeight: 400,
                    ...(pathname.startsWith(item.href) && { fontWeight: 600 }),
                  }}
                >
                  {item.label}
                </Link>
              ))}
            </Box>

            {/* Spacer for desktop to push items to the right - hidden on mobile */}
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }} />

            <StoreFrontRightArea hideConnectButton />
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Drawer */}
      <StoreFrontDrawer open={mobileOpen} onClose={handleDrawerToggle} />

      <UnpaidOrdersPopup />
    </>
  );
}
